import { ReactNode } from "react";
import cx from "classnames";

import TextButton from "client/common/components/buttons/TextButton";

import styles from "../styles/AppliedFilters.module.less";

type AppliedFiltersProps = {
  children: ReactNode;
  /** Passed explicitly because the row cannot tell whether its children rendered anything. */
  hasSelectedFilters: boolean;
  onClearAll: () => void;
  /** Shares the result count's line, to its right. */
  isBesideCount?: boolean;
};

const AppliedFilters = ({
  children,
  hasSelectedFilters,
  onClearAll,
  isBesideCount = false,
}: AppliedFiltersProps) => {
  if (!hasSelectedFilters) {
    return null;
  }

  return (
    <div className={cx(styles.row, isBesideCount && styles.besideCount)}>
      {children}
      <TextButton type="button" className={styles.clearAll} onClick={onClearAll}>
        Clear all
      </TextButton>
    </div>
  );
};

export default AppliedFilters;
